// @flow

import * as React from 'react';
import {Helmet} from 'react-helmet-async';
import Favicon from 'docs/images/favicon.png';

export const DocsFavicon = () => {
  // This is written like this due to a issue with Helmet when used
  // in tests
  const faviconHref: string =
    typeof Favicon === 'string' ? Favicon : Favicon.default;
  return (
    <Helmet>
      <link rel="icon" href={faviconHref} type="text/png" />
    </Helmet>
  );
};
